import { Tooltip as AntdTooltip, TooltipProps as AntdTooltipProps } from "antd";

import { CMP_PREFIX } from "@/base/constant";

export const tooltipPrefixCls = `${CMP_PREFIX}-tooltip`;

export type TooltipProps = AntdTooltipProps;

export const Tooltip = ({ ...props }: TooltipProps) => {
  return <AntdTooltip {...props} />;
};
